import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import {InputText} from "primereact/inputtext";
import {numberWithCommaDataTableTemplate} from "../../utils/formatters/Numbers";
import LinearProgress from "@material-ui/core/LinearProgress";
import UploadFilePresval from "../../components/uploadFile/uploadFileSingle";
import HeaderScreenPresval from "../../components/headerScreenPresval";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";

const TrustPosition = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Administración \ Posición Fideicomiso"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.searchContract}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <SubtitleLabel header="Contrato" isBold={true}/>
                                    <InputText id="contratoConsulta"
                                               keyfilter="pint"
                                               maxLength={10}
                                               onChange={props.onChangeTextFilter}
                                               value={props.contratoConsulta}
                                               placeholder="Ex. 9999"/>
                                </div>
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12}>
                        <div style={{textAlign: 'right'}}>
                            <UploadFilePresval type={["text/txt", "text/plain"]} size="1000"
                                               urlAction="/appapv/uploadFilePositionFideicomiso.action"
                                               errorTypeMessage="El documento debe ser txt."
                                               errorSizeMessage="El archivo es muy pesado."
                                               instructions="Debe ser un archivo de texto con comas de separación entre los datos."
                                               className="p-button-secondary"/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.dataPositions}
                            responsive={true}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="contrato" header="Contrato" sortable={true}
                                    style={{textAlign: 'left'}}/>
                            <Column field="nomEmision" header="Emisora" sortable={true}
                                    style={{textAlign: 'left'}}/>
                            <Column field="serie" header="Serie" sortable={true}
                                    style={{textAlign: 'left'}}/>
                            <Column field="cupon" header="Cupon" sortable={true}
                                    style={{textAlign: 'left'}}/>
                            <Column field="isin" header="ISIN" sortable={true}
                                    style={{textAlign: 'left'}}/>
                            <Column field="tipoValor" header="Tipo Valor" sortable={true}
                                    style={{textAlign: 'left'}}/>
                            <Column field="cantidad" header="Títulos" sortable={true}
                                    style={{textAlign: 'left'}}
                                    body={numberWithCommaDataTableTemplate}
                            />
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>


        </React.Fragment>
    )
};

export default TrustPosition;